import { Input } from '@tempo-io/sui-input';

interface InlineEditableTextProps {
  id?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  testId: string;
  ddActionName: string;
}

export const InlineEditableText = ({
  id,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  disabled,
  testId,
  ddActionName,
  helperText,
}: InlineEditableTextProps) => (
  <div>
    <Input
      id={id}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      data-testid={testId}
      data-dd-action-name={ddActionName}
      aria-invalid={error || undefined}
      className="!text-lg !font-medium !leading-6 !tracking-tight !text-text-neutral-primary !text-ellipsis !border-0 !shadow-none hover:!border hover:!border-border-focus-neutral hover:!shadow-none focus:!border focus:!shadow"
    />
    {error && helperText && <span className="mt-1 text-xs text-text-error">{helperText}</span>}
  </div>
);
